<template>
  <div class="pfslide"  style="margin-bottom: 5px">
    <div class="pfslide__title pfslide__title_smspace" v-html="title"></div>
    <div class="pfslide__smtitle">Укажите Ваши паспортные данные</div>
    <div class="pfslide__thincontent">
      <div class="pfslidepsflex">
        <div class="pfslidepsflex__first">
          <NumberInput 
            text='Серия и номер паспорта'
            name='p-number'
            mask='#### ######'
            :filled="(v)=>v.length==11"
            v-model="client.passport.series"/>
        </div>
        <div class="pfslidepsflex__last">
          <DateInput
            text='Дата выдачи'
            name='p-releasedate'
            :startAt="'2015-01-01'"
            v-model="client.passport.date"
            :validation="releasedateValidation"
            />
        </div>
      </div>
      <TextInput text='Место рождения' name='pob' v-model="client.pob" :options="birthplaceSuggest"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import slide from '../../mixins/slide.vue'
import NumberInput from '../inputs/NumberInput.vue';
import TextInput from '../inputs/TextInput.vue';
import DateInput from '../inputs/DateInput.vue';  
  export default {
    name: "slide3",
    mixins: [slide],
    components: { NumberInput, TextInput, DateInput },
    data: ()=>({
      birthplaceSuggest: []
    }),
    methods: {
      releasedateValidation: (date)=> {
        if (Date.now() - date < 0)
          return 'Указана дата из будущего'
        let y = new Date().getFullYear(),
            m = new Date().getMonth(),
            d = new Date().getDate()
        if (date < new Date(y-69, m, d))
          return 'Не может быть больше 69 лет'
        return ''
      },
      async suggestAddress(query) {
            let url = this.DaData.urls.address, token = this.DaData.token, options = {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": "Token " + token
                },
                body: JSON.stringify({ query: query, count: 5 })
            };
            let sg = await (fetch(url, options)
                .then(response => response.json())
                .then(res => res.suggestions.filter(el => el.data))
                .catch(() => []))
            this.birthplaceSuggest = sg.map(el => el.value);
        }
    },
    computed: {
      ...mapState(['DaData'])
    },
    watch: {
      'client.pob'(v){
        this.suggestAddress(v)
      }
    }
}
</script>

<style lang="sass">
.pfslidepsflex
  width: 100%
  display: flex
  justify-content: space-between
  position: relative
  z-index: 2
  &__first
    width: 59.6%
  &__last
    width: 29.8%
  &_alt
    .pfslidepsflex__first
      flex-grow: 1
      width: auto
      margin-right: 16px
    .pfslidepsflex__last
      width: 100px
  &__first:last-child
    margin-right: 0 
    width: 100% 
  @include from(globalvars.$nano)
    display: block
    & &__first, & &__last
      width: 100%
    & &__first
      margin-bottom: 32px
      margin-right: 0
</style>